import { setContext } from "@apollo/client/link/context";

const token = sessionStorage.getItem("token");

const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : "",
    },
  };
});

export default authLink;
